export const GOOGLE_MAPS_API_KEY = window.__GOOGLE_PLACE_API_KEY__ || 'AIzaSyAJ5xOLytZDDRdeLzkZOKWrXiyKhkOVKfU';
